import * as React from 'react';
const LaringiteIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M99.25 121.8c-4.34 3.2-9 5.77-14.14 7.27-3.58 1.04-8.09 2.09-11.54 0-1.5-.9-2.63-2.69-2.42-4.51.09-.79.43-1.53.52-2.32s-.09-1.39-.74-1.78c-.57-.34-1.12-.77-1.49-1.35s-.55-1.33-.35-2 .85-1.18 1.51-1.13c-.74-.12-1.45-.65-1.81-1.35s-.39-1.58-.08-2.31c.18-.42.45-.77.67-1.16s.39-.84.33-1.29-.32-.83-.75-.78c-.77-.37-1.56-.75-2.23-1.31-2.46-2.06-2.22-4.36-.42-6.86 1.42-1.97 2.96-4.09 3.58-6.46.7-2.67.24-5.51.33-8.22.31-9.1 6.37-18.31 13.26-23.93 2.97-2.42 6.28-4.25 9.84-5.46 0 0 1.82-.86 6.68-1.54 11.71-1.62 23.89 1.78 30.05 12.39 3.8 6.25 5.52 13.76 4.9 21.07-.63 7.47-5.02 13.38-8.43 19.79-2.43 4.57-4.09 9.67-3.98 14.85M130.49 145.1c-2.99-4.41-5.45-9.74-6.87-15.03"
      className="prefix__cls-2"
    />
    <path
      d="M86.13 128.91c2 5.56 4.38 10.98 7.12 16.19M107.58 95.59c.81-1.75 2.03-3.37 3.73-4.15 1.69-.79 3.9-.55 5.11.91.9 1.07 1.13 2.58 1.16 4.01.07 3.55-.94 7.12-2.85 10.05-.86 1.32-1.92 2.53-3.25 3.29-1.34.76-2.99 1.02-4.4.43"
      className="prefix__cls-2"
    />
    <path
      d="M111.35 99.9c-.36.94-.86 1.82-1.49 2.61-.03.03-.07.07-.11.05s.03-.09.03-.05"
      className="prefix__cls-2"
    />
    <circle cx={106.23} cy={139.14} r={2.14} className="prefix__cls-1" />
    <path d="M102.73 128.91s1.64 9.6 8.62 18.12" className="prefix__cls-1" />
  </svg>
);
export default LaringiteIcon;
